"use client"

import { Clover } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CloverIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CloverIcon = component(Icon)({ as: Clover })
